import isEmpty from 'is-empty';
import {
  WITHDRAW_TARGET_SAVING_SUCCESS,
  WITHDRAW_TARGET_SAVING_ERROR,
  WITHDRAW_TARGET_SAVING_LOADING,
  WITHDRAW_TARGET_SAVING_ERROR_DELETE
} from '../../actions/types';

const initialState = {
  success: false,
  withdrawTargetSavings: {},
  error: '',
  loading: false
};

const WithdrawTargetSavings = (state = initialState, action) => {
  switch (action.type) {
    case WITHDRAW_TARGET_SAVING_SUCCESS:
      return {
        ...state,
        withdrawTargetSavings: action.withdrawal,
        success: !isEmpty(action.withdrawal),
        loading: false
      };
    case WITHDRAW_TARGET_SAVING_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case WITHDRAW_TARGET_SAVING_ERROR_DELETE:
      return {
        ...state,
        error: '',
        loading: false
      };
    case WITHDRAW_TARGET_SAVING_LOADING:
      return {
        ...state,
        loading: true
      };
    default: return state;
  }
};

export default WithdrawTargetSavings;
